
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24 12.145c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12Zm-6.94-4.721L5.49 11.885c-.792.31-.778.749-.135.953l2.962.924 6.87-4.326c.32-.212.616-.092.374.121L10 14.58l-.213 3.053c.31 0 .445-.135.605-.295l1.447-1.394 3 2.211c.547.31.938.15 1.084-.508l1.97-9.281-.001.001c.174-.812-.295-1.137-.832-.943Z","fill":"#039BE5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .145)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    